// extracted by mini-css-extract-plugin
module.exports = {"copyrightSection":"copyright-section-module--copyright-section--2EcEb","footerDark":"copyright-section-module--footer-dark--2aANL"};